/* eslint-disable @typescript-eslint/no-unused-vars */
import { DossierOpenSearch } from '@europrocurement/l2d-domain';
import { createContext, useContext } from 'react';

export type DossierAction =
    | 'manageGroups'
    | 'cancel'
    | 'validate'
    | 'suspend'
    | 'unsuspend'
    | 'export'
    | 'urgent'
    | 'assign'
    | 'selectGreffe'
    | undefined;

let currentAction: DossierAction;

const dossiers: Array<DossierOpenSearch> = [];
const dossiersUpdated: Array<DossierOpenSearch> = [];

const setDossiersUpdated: React.Dispatch<React.SetStateAction<Array<DossierOpenSearch>>> = () => {};

const triggerAction = (action: DossierAction, selectedDossier: Array<DossierOpenSearch>) => {};
const cancelCurrentAction = () => {};
const confirmCurrentAction = () => {};
const refreshDossiers = () => {};
const updatingDossier = false;

const DossierActionContext = createContext({
    dossiers,
    currentAction,
    dossiersUpdated,
    setDossiersUpdated,
    triggerAction,
    cancelCurrentAction,
    confirmCurrentAction,
    refreshDossiers,
    updatingDossier,
});

export const useDossierActionContext = () => useContext(DossierActionContext);

export default DossierActionContext;
